var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"page-not-found"}},[_c('div',{staticClass:"wrapper"},[(_vm.$i18n.locale && _vm.$i18n.locale.toLowerCase().includes('fr'))?_c('page-not-found-image-fr',{staticClass:"image"}):_c('page-not-found-image-en',{staticClass:"image"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }